module.exports = __webpack_public_path__ + "static/img/6448_phase_function_Paper_Points.f559b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6448_phase_function_Paper_Points.png
// module id = Xz/2
// module chunks = 0